import React, { Component } from "react";
import UI from "../../shared/Components/UI/js";
import { 
  // StyleSheet,
   Text, View } from "../../shared/custom-react-native";
import "./css.css";
const zIndex = 10001;
export default class Loading extends Component {
  constructor(props) {
    super(props);
    this.state = {
      speed: 1.1,
    };
  }

  componentDidMount = () => {};

  render() {
    let props = this.props;
    let { visible, title, text, modal_opaque } = props;
    return (
      <View
        style={{
          height: "100%",
          width: "100%",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: zIndex,
          backgroundColor: modal_opaque
            ? "rgba(255,255,255,1)"
            : "rgba(255,255,255,0.85)",
          justifyContent: "center",
          alignItems: "center",
          display: visible ? "flex" : "none",
        }}
      >
        <img
          style={{
            height: 50,
            width: 50,
            userSelect: "none",
            animation: `spin ${this.state.speed}s linear infinite`,
          }}
          src={UI.LOADER}
          alt="loader"
        />
        <Text style={{ textAlign: "center", fontSize: 20, fontWeight: "bold" }}>
          {title}
        </Text>
        <Text style={{ textAlign: "center" }}>{text}</Text>
      </View>
    );
  }
}

// const styles = StyleSheet.create({});

export class LoadingEncounter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      speed: 1.1,
    };
  }

  componentDidMount = () => {};

  render() {
    let props = this.props;
    let { visible, title, text, modal_opaque } = props;
    return (
      <View
        style={{
          height: "100%",
          width: "100%",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: zIndex,
          backgroundImage: modal_opaque
            ? "rgba(255,255,255,1)"
            : "linear-gradient(rgba(0,0,0,0.7),rgba(0,0,0,0.7))",
          justifyContent: "center",
          alignItems: "center",
          display: visible ? "flex" : "none",
        }}
      >
        <img
          style={{
            height: 50,
            width: 50,
            userSelect: "none",
            animation: `spin ${this.state.speed}s linear infinite`,
          }}
          src={UI.LOADER}
          alt="loader"
        />
        <Text style={{ textAlign: "center", fontSize: 20, fontWeight: "bold", color: "white" }}>
          {title}
        </Text>
        <Text style={{ textAlign: "center", color: "#0E4D94 !important" }}>{text}</Text>
      </View>
    );
  }
}


